import { MAIN_ENDPOINT } from "../../../config/api-client";

export const QUERY_KEY = "profile";
export const ENDPOINT = MAIN_ENDPOINT;
